import { combineReducers } from "redux";

import requestTypeList from "./requestTypeList";
import fetching from "./fetching";

export default combineReducers({ requestTypeList, fetching });
